import { render, staticRenderFns } from "./AdminKeyboard.vue?vue&type=template&id=e21f8a9a"
import script from "./AdminKeyboard.vue?vue&type=script&lang=js"
export * from "./AdminKeyboard.vue?vue&type=script&lang=js"
import style0 from "./AdminKeyboard.vue?vue&type=style&index=0&id=e21f8a9a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports